@if (spinner) {
  <app-spinner></app-spinner>
}

<div class="inner-page-header">
  <h3>ملف الوحدة</h3>
</div>

@if (unitData && !spinner) {
  <div class="unit-details-container">
     <div class="button-container">
    <button class="btn btn-edit" (click)="editUnit()">تعديل</button>
  </div>
    <!-- Main Info Card -->
    <div class="main-info-card">
      <div class="card-header">
        <h3>ملف الوحدة</h3>
      </div>

      <div class="card-body">
        <div class="info-grid">
          <div class="info-item customer-info">
            <label class="form-label">اسم العميل</label>
            <div class="customer-name-wrapper">
              @if (unitData?.stakeholder?.id) {
                <a
                  (click)="goToCustomerProfile(unitData?.customer_id)"
                  class="customer-link"
                >
                  {{ unitData?.stakeholder?.name || "-" }}
                </a>
              }
              @if (unitData?.stakeholder?.phone_number) {
                <span class="custom-tooltip">
                  <img src="assets/images/svg/phone-tooltip.svg" alt="" />
                  <span
                    class="tooltip-text clickable"
                    (click)="copyClientMobile()"
                  >
                    {{ unitData?.stakeholder?.phone_number || "-" }}
                    <img
                      src="assets/images/svg/copy-report-link.svg"
                      alt="copy"
                      style="
                        width: 14px;
                        height: 14px;
                        margin-left: 4px;
                        cursor: pointer;
                      "
                    />
                  </span>
                </span>
              }
              @if (unitData?.stakeholder?.email) {
                <span class="custom-tooltip">
                  <img src="assets/images/svg/email-tooltip.svg" alt="" />
                  <span class="tooltip-text">{{
                    unitData?.stakeholder?.email || "-"
                  }}</span>
                </span>
              }
            </div>
          </div>
          <div class="info-item">
            <label class="form-label">نوع العلاقة</label>
            <p>
              @for (
                relation of unitData.property_relations;
                track relation.id;
                let i = $index;
                let count = $count
              ) {
                <span
                  >{{ relation.name || "-" }}
                  @if (i < count - 1) {
                    ،
                  }
                </span>
              }
              @if (
                !unitData.property_relations ||
                unitData.property_relations.length === 0
              ) {
                <span>-</span>
              }
            </p>
          </div>

          <div class="info-item">
            <label>تاريخ الإنشاء</label>
            <p>{{ unitData.created_at || "-" }}</p>
          </div>

          <div class="info-item">
            <label>عمر العقار</label>
            <p>{{ unitData.age || "-" }}</p>
          </div>
          <div class="info-item">
            <label>اسم العقار للعميل</label>
            <p>{{ unitData.unit_name || "-" }}</p>
          </div>
          <div class="info-item">
            <label>تاريخ اخر تعديل</label>
            <p>{{ unitData.last_visit_at || "-" }}</p>
          </div>
          <div class="info-item">
            <label>نوع العقار</label>
            <p>{{ unitData.property_type || "-" }}</p>
          </div>
          <div class="info-item">
            <label>رقم المبنى</label>
            <p>{{ unitData.address_building_code || "-" }}</p>
          </div>
          <div class="info-item">
            <label>المدينة</label>
            <p>{{ unitData.address_city?.name || "-" }}</p>
          </div>
          <div class="info-item">
            <label>المنطقة</label>
            <p>{{ unitData.address_area?.name || "-" }}</p>
          </div>
          <div class="info-item">
            <label>الحي</label>
            <p>{{ unitData.district?.name || "-" }}</p>
          </div>
          <div class="info-item">
            <label>الشارع</label>
            <p>{{ unitData.address_street || "-" }}</p>
          </div>
          <div class="info-item">
            <label>العنوان الوطني</label>
            <p>{{ unitData.short_address || "-" }}</p>
          </div>
          <div class="info-item">
            <label>علامة مميزة</label>
            <p>{{ unitData.landmark || "-" }}</p>
          </div>
        </div>

        <!-- Map Section - Positioned absolutely on the left -->
        @if (unitData.location && apiLoaded) {
          <div class="map-section">
            <div class="map-container">
              <google-map width="100%" height="229px" [options]="mapOptions">
                <map-marker [options]="markerOptions"></map-marker>
              </google-map>
            </div>

            <div class="map-address">
              <label>العنوان الكامل</label>
              <p>{{ getFullAddress() }}</p>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Related Orders Section -->
    <div class="expansion-section">
      <mat-accordion>
        <mat-expansion-panel
          [(expanded)]="relatedOrdersExpanded"
          class="custom-expansion-panel"
        >
          <mat-expansion-panel-header class="custom-header">
            <mat-panel-title>الطلبات المرتبطة</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="panel-content">
            <button class="btn btn-primary-blue" (click)="goToRelatedOrders()">
              اضغط هنا للاطلاع على الطلبات
            </button>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <!-- Change History Section -->
    <div class="expansion-section">
      <mat-accordion>
        <mat-expansion-panel
          [(expanded)]="changeHistoryExpanded"
          class="custom-expansion-panel"
        >
          <mat-expansion-panel-header class="custom-header">
            <mat-panel-title>سجل التغييرات</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="panel-content">
            @if (unitData.logs && unitData.logs.length > 0) {
              <div class="change-history">
                @for (group of unitData.logs; track group.period || $index) {
                  <div class="history-group">
                    @if (group.period) {
                      <div class="period-label">{{ group.period }}</div>
                    }
                    @if (group.changes && group.changes.length > 0) {
                      @for (change of group.changes; track $index) {
                        <div class="history-item">
                          <h4 class="change-title">{{ change.title }}</h4>
                          <span class="change-time">{{ change.time }}</span>
                        </div>
                      }
                    }
                  </div>
                }
              </div>
            }

            @if (!unitData.logs || unitData.logs.length === 0) {
              <div class="no-data">
                <p>لا توجد تغييرات مسجلة</p>
              </div>
            }
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <!-- Property Files Section -->
    <div class="expansion-section">
      <mat-accordion>
        <mat-expansion-panel
          [(expanded)]="propertyFilesExpanded"
          class="custom-expansion-panel"
        >
          <mat-expansion-panel-header class="custom-header">
            <mat-panel-title>ملفات العقار</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="panel-content files-panel">
            @if (propertyFiles && propertyFiles.length > 0) {
              <div class="property-files-grid">
                @for (file of propertyFiles; track file.id || file.key) {
                  <div class="file-item">
                    <label class="file-label">{{ file.label }}</label>
                    <button
                      class="file-button"
                      [class.file-available]="file.url"
                      [class.file-unavailable]="!file.url"
                      [disabled]="!file.url"
                      (click)="downloadFile(file)"
                    >
                      @if (file.url) {
                        <img
                          src="assets/images/svg/file-unit-icon.svg"
                          alt="file"
                          class="file-icon"
                        />
                      }
                      <span class="button-text">
                        {{ file.url ? "الملف المرفق" : "لا يوجد ملف مرفق" }}
                      </span>
                    </button>
                  </div>
                }
              </div>
            } @else {
              <div class="no-data">
                <p>لا توجد ملفات متاحة</p>
              </div>
            }
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
}

@if (errorMessage && !spinner) {
  <div class="error-message">
    <p>{{ errorMessage }}</p>
  </div>
}
